// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__25RgZ","tab":"ProcedureTabs_tab__1Qchv"};